import api from '../utils/api';

/**
 * مقایسهٔ ردیف‌های فایل انبار با موجودی سیستم (بدون تغییر دیتابیس)
 * @param {{ code: string|number, name?: string, stock: number|null }[]} rows
 */
export const previewWarehouseStock = async (rows) => {
  const response = await api.post('/warehouse-stock/preview', { rows });
  return response.data;
};

/**
 * اعمال موجودی فایل روی تنوع‌ها؛ اجرا در پس‌زمینه انجام می‌شود و importId برمی‌گردد
 * @param {{ rows: object[], fileName?: string, codes?: string[] }} data
 */
export const applyWarehouseStock = async (data) => {
  const response = await api.post('/warehouse-stock/apply', data);
  return response.data;
};

export const getWarehouseImports = async () => {
  const response = await api.get('/warehouse-stock/imports');
  return response.data;
};

export const getWarehouseImport = async (id) => {
  const response = await api.get(`/warehouse-stock/imports/${id}`);
  return response.data;
};
